import ContextBadges from "../ContextBadges";
import InlineEditableField from "../InlineEditableField";
import { relationshipColor } from "../../lib/relationshipColors";

function ageFrom(birthday) {
  if (!birthday) return null;
  const born = new Date(`${birthday}T12:00:00`);
  if (Number.isNaN(born.getTime())) return null;
  const now = new Date();
  let age = now.getFullYear() - born.getFullYear();
  const beforeBirthday =
    now.getMonth() < born.getMonth() ||
    (now.getMonth() === born.getMonth() && now.getDate() < born.getDate());
  if (beforeBirthday) age -= 1;
  return age >= 0 && age < 130 ? age : null;
}

/** Who this is, across the top of the page, before any detail. */
export default function ProfileMasthead({
  name,
  relationshipType,
  whereMet,
  birthday,
  availableContexts,
  activeContext,
  onContextChange,
  onChangeWhereMet,
}) {
  const age = ageFrom(birthday);

  return (
    <header className="profile-masthead">
      <div className="profile-masthead-identity">
        {relationshipType && (
          <p className="profile-kind" style={{ color: relationshipColor(relationshipType) }}>
            <span className="profile-kind-rule" aria-hidden="true" />
            {relationshipType}
          </p>
        )}
        <h1 className="profile-name">{name}</h1>
        <p className="profile-subline">
          {age !== null && <span>{age} years old</span>}
          <InlineEditableField
            value={whereMet || ""}
            label="how you met"
            placeholder="How did you meet?"
            onSave={onChangeWhereMet}
          />
        </p>
      </div>

      {availableContexts.length > 0 && (
        <div className="profile-facets">
          <ContextBadges
            contexts={availableContexts}
            activeContext={activeContext}
            onSelect={availableContexts.length > 1 ? onContextChange : undefined}
          />
        </div>
      )}
    </header>
  );
}
